import type { TranscendIndividualTraits } from '../types';
import { cleanEmail } from './clean-email';
import { emailToUserId } from './user-id';

export async function formatIdentify({
  email,
  traits,
}: {
  email: string;
  traits?: TranscendIndividualTraits | undefined;
}): Promise<{
  formattedUserId: string;
  formattedTraits: TranscendIndividualTraits;
}> {
  // Clean the email
  const formattedEmail = cleanEmail(email);

  // SHA-256 of email
  const formattedUserId = await emailToUserId(formattedEmail);

  // Format the traits object
  const formattedTraits: TranscendIndividualTraits = {
    ...traits,
    email: formattedEmail,
  };

  return { formattedUserId, formattedTraits };
}
